import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-decoration: none;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;

  ${({ theme }) => css`
    padding: 18px 40px 15px 40px;
    min-width: 160px;
    background-color: ${theme.colors.translucentBlack};
    font-family: ${theme.fontFamilies.italianPlate};
    &:hover {
      color: ${theme.colors.primary};
    }
    color: ${theme.colors.white};
    border-left: 1px solid ${theme.colors.defaultAdd2};
    &:last-child {
      margin-right: 0;
      border-right: 1px solid ${theme.colors.defaultAdd2};
    }
    @media (min-width: ${theme.breakpoints.sm}) {
      padding: 22px 58px 18px 58px;
      min-width: 196px;
    }
  `}
  ${({ theme, $isActive }) =>
    $isActive &&
    css`
      color: ${theme.colors.primary};
      font-weight: 600;
      border-bottom: 2px solid ${theme.colors.primary};
    `}
`;
